export interface DirectMetricsUI {
    counters: DirectMetricsCounterUI[];
    goals: DirectMetricsGoalUI[];
}

export interface DirectMetricsCounterUI {
    id: string;
    domain: string;
    goals: string[];
}

export interface DirectMetricsGoalUI {
    counterId: string;
    id: string;
    name: string;
}

export enum DirectStrategyType {
    MAX_CONVERSIONS = 'MAX_CONVERSIONS',
    MAX_CLICKS = 'MAX_CLICKS',
}

export enum DirectPayForType {
    CLICKS = 'CLICKS',
    CONVERSIONS = 'CONVERSIONS',
}

export enum DirectBudgetType {
    WEEKLY_LIMIT = 'weekly_limit',
    PERIOD_LIMIT = 'period_limit',
    NO_LIMIT = 'no_limit',
}

export enum DirectSpendLimitType {
    /** средняя цена клика */
    AVERAGE_CPC = 'average_cpc',
    /** средняя цена конверсии */
    AVERAGE_CPA = 'average_cpa',
    /** бюджет */
    WEEKLY_LIMIT = 'weekly_limit',
    /** средняя цена конверсии */
    CONVERSION_COST = 'conversion_cost',
    /** доля рекламных расходов */
    CRR = 'crr',
}

export enum DirectGoalCostType {
    DYNAMIC = 'DYNAMIC',
    MANUAL = 'MANUAL',
}

// Типы для кампаний
export interface DirectGoalDto {
    goal_id: string;
    name: string;
    cost?: number;
    is_metrika_source_of_value?: boolean;
}

export interface DirectCounterDto {
    counter_id: string;
    domain: string;
    goals: DirectGoalDto[];
}

export interface DirectRegionDto {
    region_id: number;
    name: string;
}

export interface DirectCampaignLinksDto {
    mol: string;
}

export type DirectCampaignStatusDto = 'DRAFT' | 'ACCEPTED' | 'MODERATION' | 'REJECTED' | 'UNKNOWN';

export type DirectCampaignStateDto =
    | 'ON'
    | 'OFF'
    | 'ARCHIVED'
    | 'CONVERTED'
    | 'ENDED'
    | 'SUSPENDED'
    | 'UNKNOWN';

export interface DirectCampaignDataDto {
    id: number;
    login: string;
    name: string;
    start_date: string;
    status: DirectCampaignStatusDto;
    state: DirectCampaignStateDto;
    weekly_limit: number;
    counters: DirectCounterDto[];
    regions: DirectRegionDto[];
    links: DirectCampaignLinksDto;
    tracking_params?: string;
    strategy_type?: DirectStrategyType;
    pay_for?: DirectPayForType;
    budget_type?: DirectBudgetType;
    spend_limit_type?: DirectSpendLimitType;
    spendLimitAmount?: number;
    average_cpc?: number;
    crr?: number;
}

export interface DirectFeedSettingsDto {
    banned_post_ids: string[];
    use_all_posts: boolean;
    freshness_days: number;
}

export interface DirectDataItemDto {
    campaign_data: DirectCampaignDataDto;
    feed_settings: DirectFeedSettingsDto;
}

export interface DirectCompaniesResponseDto {
    direct_data: DirectDataItemDto[];
}

export interface DirectCampaignModel {
    id: number;
    login: string;
    name: string;
    startDate: string;
    status: DirectCampaignStatusDto;
    state: DirectCampaignStateDto;
    weeklyLimit: number;
    counters: DirectCounterDto[];
    regions: DirectRegionDto[];
    links: DirectCampaignLinksDto;
    feedSettings: DirectFeedSettingsDto;
    utmParams?: string;
    strategyType?: DirectStrategyType;
    payFor?: DirectPayForType;
    budgetType?: DirectBudgetType;
    spendLimitType?: DirectSpendLimitType;
    spendLimitAmount?: number;
}

export interface DirectCampaignUI {
    id: number;
    login: string;
    name: string;
    startDate: string;
    status: DirectCampaignStatusDto;
    state: DirectCampaignStateDto;
    weeklyLimit: number;
    counters: DirectCounterDto[];
    regions: DirectRegionDto[];
    links: DirectCampaignLinksDto;
    content: string;
    feedSettings: DirectPromotionFeedUI;
    utmParams?: string;
    strategyType?: DirectStrategyType;
    payFor?: DirectPayForType;
    budgetType?: DirectBudgetType;
    spendLimitType?: DirectSpendLimitType;
    spendLimitAmount?: number;
}

export interface DirectPromotionUI {
    businessId: string;
    campaign: DirectPromotionCampainUI;
    feedSettings: DirectPromotionFeedUI;
}

export interface DirectPromotionCampainUI {
    startDate: string;
    weeklyLimit: number;
    regions: Record<string, string>;
    counters: string[];
    goals: DirectPromotionGoalUI;
    login?: string;
    utmParams?: string;
    strategyType?: DirectStrategyType;
    payFor?: DirectPayForType;
    budgetType?: DirectBudgetType;
    spendLimitType?: DirectSpendLimitType;
    spendLimitAmount?: number;
}

export type DirectPromotionGoalUI = Record<
    string,
    { cost?: number; costType?: DirectGoalCostType }
>;

export interface DirectPromotionFeedUI {
    posts: string[];
    useAllPosts: boolean;
    freshnessDays?: number;
}

export interface DirectPromotionDto {
    business_id: string;
    campaign_data: DirectPromotionCampainDto;
    feed_settings: DirectFeedSettingsDto;
}

export interface DirectPromotionCampainDto {
    start_date: string;
    weekly_limit: number;
    region_ids: number[];
    counter_ids?: string[];
    goals?: DirectPromotionCampainGoalDto[];
    login?: string;
    tracking_params?: string;
    strategy_type?: DirectStrategyType;
    pay_for?: DirectPayForType;
    budget_type?: DirectBudgetType;
    spend_limit_type?: DirectSpendLimitType;
    crr?: number;
}

export interface DirectPromotionCampainGoalDto {
    goal_id: string;
    cost?: number;
    is_metrika_source_of_value?: boolean;
}
